var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.REGISTER()
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "form-group mb-2" },
          [
            _c("small", { staticClass: "input-title" }, [
              _vm._v("Tipo de cuenta"),
            ]),
            _vm._v(" "),
            _c("v-select", {
              staticClass: "form-control",
              class: _vm.errors.account_type ? "is-invalid" : "",
              attrs: {
                items: _vm.accounts.filter(function (e) {
                  return e.value != 0
                }),
                "hide-details": "",
              },
              on: { change: _vm.CHANGE },
              model: {
                value: _vm.data.account_type,
                callback: function ($$v) {
                  _vm.$set(_vm.data, "account_type", $$v)
                },
                expression: "data.account_type",
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.errors.account_type, function (error, index) {
              return _c(
                "small",
                { key: index, staticClass: "invalid-feedback" },
                [_vm._v(_vm._s(error))]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.data.account_type == 2
          ? _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Nombre de la Empresa"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.company,
                      expression: "data.company",
                    },
                  ],
                  staticClass: "form-control",
                  class: _vm.errors.company ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.company },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "company", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.company, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.account_type != 2
          ? _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [_vm._v("Nombre")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.first_name,
                      expression: "data.first_name",
                    },
                  ],
                  staticClass: "form-control",
                  class: _vm.errors.first_name ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.first_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "first_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.first_name, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.account_type != 2
          ? _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Apellido"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.last_name,
                      expression: "data.last_name",
                    },
                  ],
                  staticClass: "form-control",
                  class: _vm.errors.last_name ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.last_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "last_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.last_name, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group mb-2" },
          [
            _c("small", { staticClass: "input-title" }, [
              _vm._v("Tipo de Identificación"),
            ]),
            _vm._v(" "),
            _c("v-select", {
              staticClass: "form-control",
              class: _vm.errors.identification_type ? "is-invalid" : "",
              attrs: {
                items: _vm.identifications.filter(function (e) {
                  return _vm.data.account_type == 2
                    ? e.value == 2
                    : e.value != 2
                }),
                "hide-details": "",
              },
              model: {
                value: _vm.data.identification_type,
                callback: function ($$v) {
                  _vm.$set(_vm.data, "identification_type", $$v)
                },
                expression: "data.identification_type",
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.errors.identification_type, function (error, index) {
              return _c(
                "small",
                { key: index, staticClass: "invalid-feedback" },
                [_vm._v(_vm._s(error))]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group mb-2" },
          [
            _c("small", { staticClass: "input-title" }, [
              _vm._v(
                _vm._s(
                  _vm.data.account_type == 2
                    ? "Cédula Jurídica"
                    : "Identificación"
                )
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: _vm.format,
                  expression: "format",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.identification,
                  expression: "data.identification",
                },
              ],
              staticClass: "form-control",
              class: _vm.errors.identification ? "is-invalid" : "",
              attrs: { type: "text" },
              domProps: { value: _vm.data.identification },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.data, "identification", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.errors.identification, function (error, index) {
              return _c(
                "small",
                { key: index, staticClass: "invalid-feedback" },
                [_vm._v(_vm._s(error))]
              )
            }),
            _vm._v(" "),
            _vm.data.account_type == 2
              ? _c("small", [
                  _vm._v(
                    "Ejemplo: Si es 3-101-123456 se debe digitar 3101123456"
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mb-2" }, [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Correo electrónico"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.email,
                    expression: "data.email",
                  },
                ],
                staticClass: "form-control",
                class: _vm.errors.email ? "is-invalid" : "",
                attrs: { type: "email" },
                domProps: { value: _vm.data.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.email, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mb-3" }, [
          _c("small", { staticClass: "input-title" }, [_vm._v("Contraseña")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "form-control",
                class: _vm.errors.password ? "is-invalid" : "",
                attrs: {
                  "append-icon": _vm.type ? "mdi-eye" : "mdi-eye-off",
                  type: _vm.type ? "text" : "password",
                  "hide-details": "",
                },
                on: {
                  "click:append": function ($event) {
                    _vm.type = !_vm.type
                  },
                },
                model: {
                  value: _vm.data.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "password", $$v)
                  },
                  expression: "data.password",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.password, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-x w-100",
              attrs: { type: "submit" },
            },
            [
              _vm.count == 1
                ? _c(
                    "div",
                    {
                      staticClass: "spinner-border spinner-border-sm",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading..."),
                      ]),
                    ]
                  )
                : _c("span", [_vm._v("Afiliarme")]),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-4 d-flex justify-content-start gap-2" }, [
      _c(
        "div",
        { staticClass: "mb-3" },
        [
          _vm._v("¿Ya tienes una cuenta?"),
          _c("router-link", { attrs: { to: { name: "Login" } } }, [
            _vm._v(" Iniciar sesión"),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 mb-2 text-left" }, [
      _c("h3", { staticClass: "text-lg mb-1" }, [
        _vm._v("Bienvenido de nuevo"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-md text-muted" }, [
        _vm._v(
          "Registrate para acceder a su casillero de compras internacionales."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-envelope" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-lock" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }